<template>
  <div class="jobDetail jobposingList breadcrumbs-absolute" :class="{'jobDetailPC':$store.state.innerWidth>768}" @click="closeSelectList" >
    <Breadcrumbs></Breadcrumbs>
    <FindOpportunity ref="findO" v-bind:childLogGaEvent="childLogGaEvent" :jobType="jobType" :filterActive="filterActive" :jobSource="jobSourceId" v-bind:needOptions="true" :search="searchEvent"></FindOpportunity>

    <div class="opp-contain row" style="overflow: initial !important;" ref="jobContent">
      <div class="opportunityPC opportunityPC-findJia">
        <div class="descriptionPC-left col-sm-4 col-md-4 padLeft-0 padRight-0 " style="min-height:450px;" :class="{'maxHeight':$store.state.innerWidth>768}" ref="jobList" >
          <div>
            <div class="pad-15 row pad-30">
              <div>{{totalRows}} {{$t('message.results')}}  <span v-if="occupationId"> {{$t('message.for')}}{{$store.getters.getContent(occupationDetail.title)}}{{$t('message.forEnd')}}</span></div>
            </div>
            <div
              class="pad-15  pad-30 row border-top bTop-1 jobPostingItem pointer"
              v-for="(item,index) in aok"
              :key="index"
              v-on:click="goToJobDetails(item.id,$store.getters.getContent(item.title))"
              :class="{'selectJob':jobPostingId==item.id}"
            >
              <a href="javascript:;" style="color: inherit">
              <h3 class="SemiBold wrap" :class="{'font-size-21':$store.state.innerWidth>768}" v-html="$store.getters.getContent(item.title)"></h3>
              </a>
              <a class="displayA" v-bind:href="'./jobDetail/'+item.id+'?lang='+$store.state.language+'&name='+$store.getters.replaceEvent($store.getters.getContent(item.title))"></a>
              <div class="item-table" v-if="$store.getters.getContent(item.organization)">
                <div class="tdcell iconWidth">
                  <i class="icon-hourse"></i>
                </div>
                <div class="tdcell pad-l-10">
                  <p v-html="$store.getters.getContent(item.organization)"></p>
                </div>
              </div>
              <div class="item-table"  v-if="$store.getters.getContent(item.department)">
                <div class="tdcell iconWidth">
                  <i class="icon-user"></i>
                </div>
                <div class="tdcell pad-l-10">
                  <p v-html="$store.getters.getContent(item.department)"></p>
                </div>
              </div>
              <p class="gray dateTime" :class="{'font-size-18':$store.state.innerWidth>768}">
                <span v-if="item.advertisingDay!=null">{{formatDay(item.advertisingDay)}}</span>
                <span class="hotPicks" v-if="item.isHotpick">
                  <i class="icon-hot"></i> 
                  <span>{{$t('message.hotPicks')}}</span>
                </span>
              </p>
            </div>
            <div class="bTop-1"></div>
            <div class="message-row" ref='loading' :class="{'opacity0':!isLoading}" data-load="loading">
              <span class="user-writing">
                <span></span>
              </span>
            </div>
          </div>
          <PageFindAnOpportunity  v-on:changeRow="changeStartRow" v-on:changePaging="changeSmallPaging" :courseListAll="aok" :toRows="totalRows" ref="Pa"></PageFindAnOpportunity>
        </div>
        
        <div class="descriptionPC-right col-sm-8 col-md-8 maxHeight" ref="jobDetail" v-if="$store.state.innerWidth>768">
            <div v-if="fandPrompt">
                <JobDetail v-bind:childLogGaEvent="childLogGaEvent" v-bind:jobPostingId="jobPostingId" v-if="aok.length!=0"></JobDetail>
                <div class="noResult" v-if="aok.length==0">
                    {{$t('message.noSearchResult')}}
                </div>
            </div>
            <div class="fand-prompt" v-if="!fandPrompt">
              <div><img style="width:300px;" src="../images/background-53.png" /></div>
              <div v-if="this.$store.state.language =='en_US' ">
                There are <span class="Bold">{{totalRows}}</span> job vacancies.
              </div>
          
              <div v-if="this.$store.state.language =='zh_HK' ">
                這裏提供<span class="Bold"> {{totalRows}} </span>份職位空缺。
              </div>
                  <div v-if="this.$store.state.language =='zh_CN' ">
                这里提供<span class="Bold"> {{totalRows}} </span>份职位空缺。
              </div>
              <!-- <div>{{$t('message.There are (number) jobs for you')}}</div> -->
              <div class="Bold">{{$t('message.Choose a job for more details!')}}</div>
              
            </div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div> 
    <div class="opp-contain row" style="overflow: initial !important;">
      <div class="opportunityPC findAnOpportunityOpportunity" >
        <div class="powered-by powered-by-findAnOpportunity col-sm-12 col-md-12 Bold">
            {{$t('message.Powered by')}}
        </div>
        <div class="findAnOpportunity-bottom-imgPlace col-xs-12 col-sm-12 " v-if="$store.state.innerWidth>992">
          <div class="recruit">
            <a href="https://www.recruit.com.hk" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="recruit" alt="Recruit LOGO"></a>
            <a href="https://www.recruit.com.hk" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="recruit" alt="Recruit 標誌"></a>
            <a href="https://www.recruit.com.hk" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="recruit" alt="Recruit 标志"></a>
          </div>
          <div class="cpLogo">
            <a href="https://www.cpjobs.com/hk/" target="_blank" ><img :src="cpLogo" alt="cpjobs Logo"></a>
          </div>
          <div class="ctlogo">
            <a href="https://www.ctgoodjobs.hk" target="_blank" ><img :src="ctlogo" alt="ctgoodjobs Logo"></a>
          </div>
          <div class="mjlogo">
            <a href="https://www.jobmarket.com.hk/" target="_blank" ><img :src="mjlogo" alt="jobmarket Logo"></a>
          </div>
          <div class="efcLogo">
            <a href="http://efinancialcareers.hk/?utm_medium=FEED_PART_TALENTGOV&utm_source=APAC_HK_ENG&utm_campaign=PART_LOGO" target="_blank">
              <img :src="efcLogo" alt="efinancialcareers Logo">
            </a>
          </div>

          <div class="csbLogoEn">
            <a href="https://csboa.csb.gov.hk/Redirect_JVE_en.html" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="csbLogoEn" alt="civil service bureau Logo"></a>
            <a href="https://csboa.csb.gov.hk/Redirect_JVE_tc.html" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="csbLogoEn" alt="civil service bureau 標誌"></a>
            <a href="https://csboa.csb.gov.hk/Redirect_JVE_sc.html" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="csbLogoEn" alt="civil service bureau 标志"></a>
          </div>
      
        </div>

        <div class="findAnOpportunity-bottom-imgPlaceMB" v-if="$store.state.innerWidth<=992">
          <div class="recruit col-xs-12 col-sm-12 ">
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-en/" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="recruit" alt="Recruit LOGO"></a>
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-tc/index.html" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="recruit" alt="Recruit 標誌"></a>
            <a href="https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-sc/index.html" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="recruit" alt="Recruit 标志"></a>
          </div>
          <div class="cpLogo-ctlogo col-xs-12 col-sm-12">
            <div class="cpLogo ">
              <a href="https://www.cpjobs.com/hk/" target="_blank" ><img :src="cpLogo" alt="cpjobs Logo"></a>
            </div>
            <div class="ctlogo ">
              <a href="https://www.ctgoodjobs.hk" target="_blank" ><img :src="ctlogo" alt="ctgoodjobs Logo"></a>
            </div>
          </div>
          <div class=" col-xs-12 col-sm-12 ">
            <div class="mjlogo col-sm-6 padLeft-0 padRight-0">
              <a href="https://www.jobmarket.com.hk/" target="_blank" ><img :src="mjlogo" alt="jobmarket Logo"></a>
            </div>
            <!-- <div class="csbLogoEn col-sm-6 padLeft-0 padRight-0">
              <a href="https://csboa.csb.gov.hk/Redirect_JVE_en.html" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="csbLogoEn" alt=""></a>
              <a href="https://csboa.csb.gov.hk/Redirect_JVE_tc.html" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="csbLogoEn" alt=""></a>
              <a href="https://csboa.csb.gov.hk/Redirect_JVE_sc.html" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="csbLogoEn" alt=""></a>
            </div> -->
            <div class="efcLogo col-sm-6 padLeft-0 padRight-0">
              <a href="http://efinancialcareers.hk/?utm_medium=FEED_PART_TALENTGOV&utm_source=APAC_HK_ENG&utm_campaign=PART_LOGO" target="_blank" >
                <img :src="efcLogo" alt="efinancialcareers Logo">
              </a>
            </div>
          </div>
          <div class=" col-xs-12 col-sm-12 ">
            <div class="csbLogoEn col-sm-6 padLeft-0 padRight-0">
              <a href="https://csboa.csb.gov.hk/Redirect_JVE_en.html" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="csbLogoEn" alt="civil service bureau Logo"></a>
              <a href="https://csboa.csb.gov.hk/Redirect_JVE_tc.html" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="csbLogoEn" alt="civil service bureau 標誌"></a>
              <a href="https://csboa.csb.gov.hk/Redirect_JVE_sc.html" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="csbLogoEn" alt="civil service bureau 标志"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a v-if="startRow<(totalRows/20+1)" class="displayA" v-bind:href="'./findAnOpportunity'+'?lang='+$store.state.language+'&page='+(startRow+2)"></a>
    <!-- <a v-if="startRow>0" class="displayA" v-bind:href="'./findAnOpportunity'+'?lang='+$store.state.language+'&page='+(startRow)"></a> -->
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import FindOpportunity from "@/components/FindOpportunity";
import Swiper from "@/components/Swiper.vue";
import MessageLoading from "@/components/MessageLoading";
import JobDetail from "./jobDetail"
import { EventBus } from "@/javascripts/eventBus.js";
import cpLogo from '../images/cp-logo.png';
import csbLogoEn from '../images/csb_logo_en.gif';
import ctlogo from '../images/ctlogo.png';
import mjlogo from '../images/jobmarket_process color logo.png';
import efcLogo from '../images/Logo_eFC.png';
import recruit from '../images/Recruit_with_caption_300_dpi.png';

import PageFindAnOpportunity from "@/components/pageFindAnOpportunity.vue";
export default {
  name:"FindAnOpportunity",
  data() {
    return {
      totalRows: 0,
      jobPostingList: [],
      startRow: 0,
      maxRows: 20,
      keyword: "",
      jobFunctionIds: "",
      level: "",
      type:"",
      jobSourceId:"",
      jobType:"",
      isLoading: false,
      jobPostingId:0,
      loadEnd:false,
      occupationId:"",
      occupationDetail:{},
      aok:[],
      smallPaging:1,
      numberBars:20,
      cpLogo:cpLogo,
      csbLogoEn:csbLogoEn,
      ctlogo:ctlogo,
      mjlogo:mjlogo,
      efcLogo:efcLogo,
      recruit:recruit,
      scroll:0,
      fandPrompt:false,
      hotJobList: [],
      filterActive: {
        filter: "",
        type: "",
        id: "",
      },
    }
  },   
  props:[
    "logGaEvent"
  ],
  components: {
    Breadcrumbs,
    Swiper,
    FindOpportunity,
    MessageLoading,
    JobDetail,
    PageFindAnOpportunity
  },
  computed:{
    innerheight(){
      return this.$store.state.innerHeight;
    },
    innerwidth(){
      return this.$store.state.innerWidth;
    }
  },
  created() {},
  watch:{
    innerheight (news,old) {
      if(this.$store.state.innerWidth<770){
        window.addEventListener("scroll", this.scrollEvent);
        this.$refs.jobList.style.height = 'unset';
      }else{
        this.$refs.jobList.style.height = window.innerHeight +'px';
        this.$refs.jobDetail.style.height = window.innerHeight +'px';
      }
    },
    innerwidth(news,old){
      if(this.$store.state.innerWidth<770){
        window.addEventListener("scroll", this.scrollEvent);
        this.$refs.jobList.style.height = 'unset';
      }else{
        this.$refs.jobList.style.height = window.innerHeight +'px';
        this.$refs.jobDetail.style.height = window.innerHeight +'px';
      }
      if(this.jobPostingId === 0&&this.$store.state.innerWidth>768&&this.jobPostingList.length>0){
        this.jobPostingId = this.jobPostingList[0].id;
      }
    }
  },
  methods: {
    handleScroll () {
        this.scroll  = document.documentElement.scrollTop||document.body.scrollTop;
        
    },
    closeSelectList:function(){
      if(this.$refs.Pa != undefined){
        this.$refs.Pa.closeSelecPagingList();
      }
    },
    changeSmallPaging:function(val){
      this.smallPaging = val;
      
  
    
    },
    changeStartRow:function(val){
      var that = this;
      this.startRow = val;
      this.fandPrompt = false;
      this.getJobPostingList({
        keyword: that.keyword,
        jobFunctionIds: that.jobFunctionIds,
        level: that.level,
        type: that.type,
        jobSourceId: that.jobSourceId,
        jobType: that.jobType,
      });
    },
    childLogGaEvent:function(eventCategory, eventAction, eventLabel, eventValue) {
      this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue)
    },
    getJobPostingList: function(obj) {
      let Base64 = require('js-base64').Base64
      var that = this;
      this.api.getJobPostingList({
                "startRow": that.startRow,
                "maxRows": that.maxRows,
                "keyword": Base64.encode(obj.keyword),
                "jobFunctionIds": obj.jobFunctionIds,
                "level": obj.level,
                "type": obj.type,
                "jobSourceId": obj.jobSourceId,
                "jobType": obj.jobType,
      }, function(data) {
        // that.startRow++;
        that.totalRows = data.totalRows;
        that.aok = data.result;
        for(var i=0;i<that.aok.length;i++){
          that.aok[i].id=that.aok[i].id
        }
        that.jobPostingList = data.result;
        if(that.$store.state.innerWidth>768&&that.jobPostingList.length>0){
          if(that.fandPrompt){
            that.jobPostingId = that.jobPostingList[0].id;
          }else{
            that.jobPostingId = 0;
          }
          
        }
        if(that.jobPostingList.length>=that.totalRows){
          that.loadEnd = true;
        }
        that.isLoading = false;
        if(that.$refs.jobList)

        if(that.$store.state.formData.hotJobList && that.$store.state.formData.hotJobList.length != 0) {
          that.aok = that.$store.state.formData.hotJobList;
          that.totalRows = that.$store.state.formData.hotJobList.length;
          for(var i=0;i<that.aok.length;i++){
            that.aok[i].id=encodeURIComponent(that.aok[i].id)
          }
          that.$store.state.formData.hotJobList = [];
          if(that.$store.state.formData.jobId){
            that.jobPostingId = that.$store.state.formData.jobId;
            that.fandPrompt = true;
            that.$store.state.formData.jobId = "";
          }
        }

        that.$refs.jobList.scrollTo(0,0)
      });
    },
    getOccupationJobList:function(){
      var that = this;
      let data = {
          "startRow": that.startRow,
          "maxRows": that.maxRows,
        }
      data.occupationId = that.occupationId;
      that.api.getOccupationJobList(data, function(data) {
        // that.startRow++;
        that.totalRows = data.totalRows;
        for (var i = 0; i < data.result.length; i++) {
          that.jobPostingList.push(data.result[i]);
        }
        if(that.jobPostingId === 0&&that.$store.state.innerWidth>768&&that.jobPostingList.length>0){
          that.jobPostingId = that.jobPostingList[0].id;
        }
        if(that.jobPostingList.length>=that.totalRows){
          that.loadEnd = true;
        }
        that.isLoading = false;
        if(that.startRow==0){
            setTimeout(function(){
                window.scrollTo(0,that.$refs.jobContent.offsetTop);
            })
        }
      })
    },
    goToJobDetails: function(id,name) {
        this.fandPrompt = true;
        this.logGaEvent('userClick','jobPosting',name)
        if(this.$store.state.innerWidth<770){
          this.$store.state.formData.jobFilterObj = {
              keyword: this.keyword,
              jobFunctionIds: this.jobFunctionIds,
              level: this.level,
              type: this.type,
              jobSourceId: this.jobSourceId,
              jobType: this.jobType,
          }
         setTimeout(()=>{
            this.$router.push({path:"/jobDetail/" + encodeURIComponent(id), query:{lang:this.$store.state.language,name:this.$store.getters.replaceEvent(name)}});
         },100)
        }else{
            this.jobPostingId=id;
            if(this.$refs.jobDetail){
              this.$refs.jobDetail.scrollTop = 0;
            }
        }
        // userClick jobPosting  "value"

    },
    searchEvent: function(obj) {
      this.keyword = obj.keyword;
      this.jobFunctionIds = obj.jobFunctionIds;
      this.level = obj.level;
      this.type = obj.type;
      this.jobSourceId = obj.jobSourceId;
      this.jobType = obj.jobType;
      this.jobPostingList = [];
      this.jobPostingId = 0;
      this.occupationId = "";
      this.startRow = 0;
      this.getJobPostingList(obj);
      if(this.$refs.Pa != undefined){
        this.$refs.Pa.changePageOne();
        this.$refs.Pa.closeSelecPagingList();
      }
    },
    // scrollEvent: function() {
    //   var that = this;
    //   if(this.jobPostingList&&this.jobPostingList.length==0){
    //     return;
    //   }
    //   if(that.$store.state.innerWidth<770){
    //     var e = document.querySelectorAll("[data-load]");
    //     if(e.length==0) return;
    //     if (
    //       e[0].offsetTop - window.scrollY < window.innerHeight - 200 &&
    //       !that.isLoading&&!this.loadEnd
    //     ) {
          
    //       that.isLoading = true;
    //       if(this.occupationId){
    //         this.getOccupationJobList()
    //       }else{
    //         this.getJobPostingList({
    //           keyword: that.keyword,
    //           jobFunctionIds: that.jobFunctionIds,
    //           level: that.level,
    //           type: that.type
    //         });
    //       }
    //     }
    //     return;
    //   }
    //   if (this.$refs.loading&&this.$refs.jobList&&this.$refs.loading.offsetTop <( this.$refs.jobList.scrollTop + 650+window.innerHeight) &&!that.isLoading&&!this.loadEnd) {
    //     // that.startRow++;
    //     that.isLoading = true;
    //       if(this.occupationId){
    //         this.getOccupationJobList()
    //       }else{
    //         this.getJobPostingList({
    //           keyword: that.keyword,
    //           jobFunctionIds: that.jobFunctionIds,
    //           level: that.level,
    //           type: that.type
    //         });
    //       }
    //   }
    // },
    formatDay:function(no){
      let num = "";
      if(no>=30){
        num = Math.floor(no/30) + this.$i18n.t("message.monthsAgo");
      }else if(no>=7){
        num = Math.floor(no/7) + this.$i18n.t("message.weeksAgo");
      }else if(no==0){
        num = this.$i18n.t("message.today");
      }else if(no==1){
        num = no + this.$i18n.t("message.dayAgo");
      }else{
        num = no + this.$i18n.t("message.daysAgo");
      }
      return num;
    },
    getOccupationsDetail:function(){
      var that = this;
      this.api.getOccupationDetail({ id: that.occupationId }, function(data) {
        that.occupationDetail = data.result;
      });
    }
  },
  activated(){
      var that = this;
      this.$store.state.mate.width = 209;
      this.$store.state.mate.height = 209;
      this.$store.state.selectMenu = 3;
      this.fandPrompt = false;
      this.$store.state.mate.description = this.$i18n.t("message.Job_desc");
      this.$store.state.mate.keywords = this.$i18n.t("message.Job_keywords");
      this.$store.state.mate.title = this.$i18n.t("message.Find a Job Opportunity")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
      if(this.$store.state.formData.headTabState3){ 
          this.$store.state.formData.headTabState3 = false;
          this.aok = [] //清空原有数据
          new Promise((resolve,reject)=>{
            that.level = '';
            that.$refs.findO.keyword = '';
            that.jobFunctionIds = '';
            that.jobSourceId = "";
            that.jobType = "";
            that.filterActive = {};
            that.keyword = '';
            that.$refs.findO.showExtra = false;
            that.type = '';
            if(that.$route.query.jobFunctionIds){
              that.jobFunctionIds=that.$route.query.jobFunctionIds
            }
            if(that.$route.query.keyword){
              that.keyword=that.$route.query.keyword
            }
            if(that.$route.query.jobSourceId){
              that.jobSourceId=that.$route.query.jobSourceId

              that.filterActive = {
                filter: `jobSourceFilter`,
                type: "jobSourceId",
                id: that.jobSourceId,
              }
            }
            if(that.$route.query.page){
              that.startRow = that.$route.query.page-1
            }
            that.getJobPostingList({
              keyword: that.keyword,
              jobFunctionIds: that.jobFunctionIds,
              level: that.level,
              type: that.type,
              jobSourceId: that.jobSourceId,
              jobType: that.jobType,
            });
            that.$refs.findO.getJobFunctionList();
            that.$refs.findO.getJobLevelList();
            that.$refs.findO.getJobTypeList();
            if(this.$refs.Pa != undefined){
              this.$refs.Pa.changePageOne();
              this.$refs.Pa.closeSelecPagingList();
            }
            resolve();
          }).then((data)=>{
                //  that.$refs.browseC.clearAllselect();

          })
      }
      if(this.$store.state.formData.jobId){
        this.jobPostingId = this.$store.state.formData.jobId;
        this.fandPrompt = true;
        // this.$store.state.formData.jobId = "";
      }
      EventBus.$on("hotJobList",(jobList) => {
        if(jobList && jobList.length != 0) {
          this.aok = jobList;
          this.totalRows = jobList.length;
          for(var i=0;i<this.aok.length;i++){
            this.aok[i].id=encodeURIComponent(this.aok[i].id)
          }
          this.$store.state.formData.hotJobList = [];
        } else {
          this.getJobPostingList({
            keyword: that.keyword,
            jobFunctionIds: that.jobFunctionIds,
            level: that.level,
            type: that.type,
            jobSourceId: that.jobSourceId,
            jobType: that.jobType,
          });
        }
      });
      setTimeout(()=>{
        window.scrollTo(0, that.scroll);
        
        window.addEventListener('scroll', that.handleScroll);
      },200)
   	},
   	//deactivated 页面退出时关闭事件 防止其他页面出现问题
  deactivated(){
		window.removeEventListener('scroll', this.handleScroll);
  },
  beforeRouteLeave(to, from, next){ 
        if(to.name=='jobDetail'){
         
          from.meta.isUseCache = true;
        }else{
        
          from.meta.isUseCache = false;
         
        }
        next()
  },
  mounted() {
    var that = this;
    this.$store.state.selectMenu = 3;
        this.$store.state.mate.width = 209;
        this.$store.state.mate.height = 209;
    
    window.addEventListener('scroll', this.handleScroll);
    if(that.$store.state.innerWidth<770){
      window.addEventListener("scroll", this.scrollEvent);
        this.$refs.jobList.style.height = 'unset';
    }else{
      this.$refs.jobList.style.height = window.innerHeight +'px';
      this.$refs.jobDetail.style.height = window.innerHeight +'px';
    }

    if(this.$route.query.jobFunctionIds){
      that.jobFunctionIds=this.$route.query.jobFunctionIds
    }
    if(this.$route.query.keyword){
      that.keyword=this.$route.query.keyword
    }
    if(that.$route.query.jobSourceId){
      that.jobSourceId=that.$route.query.jobSourceId

      that.filterActive = {
        filter: `jobSourceFilter`,
        type: "jobSourceId",
        id: that.jobSourceId,
      }
    }
    if(that.$route.query.page){
      this.startRow = that.$route.query.page-1
    }
    
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message.Find a Job Opportunity")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
      that.$store.state.mate.keywords = that.$i18n.t("message.Job_keywords");
    })
    this.$store.state.mate.description = this.$i18n.t("message.Job_desc");
    // if(this.$store.state.formData.occupationId){
    //   this.occupationId = this.$store.state.formData.occupationId;
    //   this.$store.state.formData.occupationId = "";
      // if(this.$store.state.formData.jobId){
      //   this.jobPostingId = this.$store.state.formData.jobId;
      //   this.fandPrompt = true;
        // this.$store.state.formData.jobId = "";
      // }
    //   this.getOccupationsDetail();
    //   this.getOccupationJobList()
    // }else{
      this.getJobPostingList({
        keyword: that.keyword,
        jobFunctionIds: that.jobFunctionIds,
        level: that.level,
        type: that.type,
        jobSourceId: that.jobSourceId,
        jobType: that.jobType,
      });
    // }
  },
};
</script>